import styled from 'styled-components';
import { Stack } from 'components/Stack';
import PpHelpOutlineIcon from '@pperform/pp-icons/PpHelpOutlineIcon';

export const Container = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
})`
  position: relative;
`;

export const LabelWrapper = styled.label`
  background-color: #fff;
  color: #888;
  font-size: 12px;
  font-weight: 700;
  left: 10px;
  max-width: 200px;
  overflow: hidden;
  padding: 0 5px;
  position: absolute;
  text-overflow: ellipsis;
  top: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;

export const InfoIcon = styled(PpHelpOutlineIcon).attrs(() => ({
  rawSvg: true,
}))`
  width: 15px;
  height: 15px;
  cursor: pointer;
  margin-left: 6px;
`;
